export default "__VITE_ASSET__ALml0pp9__"